import { useState } from 'react'
import './TierHeader.css'

interface TierHeaderProps {
  title: string
  subtitle: string
  tooltip: string
}

function TierHeader({ title, subtitle, tooltip }: TierHeaderProps) {
  const [open, setOpen] = useState(false)

  return (
    <div className="tier-header">
      <h3 className="tier-title">{title}</h3>
      <span className="tier-subtitle">{subtitle}</span>
      <span
        role="img"
        aria-label={`More info about ${title}`}
        className="tier-info-icon"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        tabIndex={0}
      >
        i
      </span>
      {open && (
        <div role="tooltip" className="tier-tooltip">
          {tooltip}
        </div>
      )}
    </div>
  )
}

export default TierHeader
